import { render, staticRenderFns } from "./preventivo.html?vue&type=template&id=653e1324&scoped=true&"
import script from "./Preventivo.vue?vue&type=script&lang=js&"
export * from "./Preventivo.vue?vue&type=script&lang=js&"
import style0 from "../../assets/styles/preventivo.css?vue&type=style&index=0&id=653e1324&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653e1324",
  null
  
)

export default component.exports